import { lazy } from 'react';

/**
 * Dialog components for agent actions are code-split: they pull in plugin
 * surfaces and form machinery that the action list itself doesn't need until
 * a user actually opens one. Kept in their own module so `useAgentActions`
 * exports only the hook (satisfies `react-refresh/only-export-components`).
 */
export const SaveAsPersonaDialog = lazy(() =>
  import('@reflex/plugin-agent-persona/web/SaveAsPersonaDialog').then((m) => ({
    default: m.SaveAsPersonaDialog,
  })),
);

export const LaunchAgainDialog = lazy(() =>
  import('@/components/agent/launch-agent-form').then((m) => ({
    default: m.LaunchAgainDialog,
  })),
);

export const SaveSnapshotDialog = lazy(() =>
  import('./SaveSnapshotDialog').then((m) => ({
    default: m.SaveSnapshotDialog,
  })),
);

export const ShareAgentDialog = lazy(() =>
  import('./ShareAgentDialog').then((m) => ({
    default: m.ShareAgentDialog,
  })),
);
